import React from 'react';
import SimpleDashboard from './SimpleDashboard';
export default function DashboardWrapper() { return <SimpleDashboard />; }
